export const TextToSpeechVoices = [
  {
    languageCode: {
      value: "ar-XA",
      label: "Arabic, multi-region",
    },
    basicNames: [
      "ar-XA-Standard-A",
      "ar-XA-Standard-B",
      "ar-XA-Standard-C",
      "ar-XA-Standard-D",
    ],
    wavenetNames: ["ar-XA-Wavenet-A", "ar-XA-Wavenet-B", "ar-XA-Wavenet-C"],
  },
  {
    languageCode: {
      value: "id-ID",
      label: "Bahasa Indonesia (Indonesia)",
    },
    wavenetNames: ["id-ID-Wavenet-A", "id-ID-Wavenet-B", "id-ID-Wavenet-C"],
    basicNames: ["id-ID-Standard-A", "id-ID-Standard-B", "id-ID-Standard-C"],
  },
  {
    languageCode: {
      value: "da-DK",
      label: "Dansk (Danmark)",
    },
    wavenetNames: ["da-DK-Wavenet-A"],
    basicNames: ["da-DK-Standard-A"],
  },
  {
    languageCode: {
      value: "de-DE",
      label: "Deutsch (Deutschland)",
    },
    wavenetNames: [
      "de-DE-Wavenet-A",
      "de-DE-Wavenet-B",
      "de-DE-Wavenet-C",
      "de-DE-Wavenet-D",
      "de-DE-Wavenet-E",
    ],
    basicNames: ["de-DE-Standard-A", "de-DE-Standard-B", "de-DE-Standard-E"],
  },
  {
    languageCode: {
      value: "en-AU",
      label: "English (Australia)",
    },
    wavenetNames: [
      "en-AU-Wavenet-A",
      "en-AU-Wavenet-B",
      "en-AU-Wavenet-C",
      "en-AU-Wavenet-D",
    ],
    basicNames: [
      "en-AU-Standard-A",
      "en-AU-Standard-B",
      "en-AU-Standard-C",
      "en-AU-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "en-GB",
      label: "English (Great Britain)",
    },
    wavenetNames: [
      "en-GB-Wavenet-A",
      "en-GB-Wavenet-B",
      "en-GB-Wavenet-C",
      "en-GB-Wavenet-D",
    ],
    basicNames: [
      "en-GB-Standard-A",
      "en-GB-Standard-B",
      "en-GB-Standard-C",
      "en-GB-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "en-IN",
      label: "English (India)",
    },
    wavenetNames: ["en-IN-Wavenet-A", "en-IN-Wavenet-B", "en-IN-Wavenet-C"],
    basicNames: ["en-IN-Standard-A", "en-IN-Standard-B", "en-IN-Standard-C"],
  },
  {
    languageCode: {
      value: "en-US",
      label: "English (United States)",
    },
    wavenetNames: [
      "en-US-Wavenet-A",
      "en-US-Wavenet-B",
      "en-US-Wavenet-C",
      "en-US-Wavenet-D",
      "en-US-Wavenet-E",
      "en-US-Wavenet-F",
    ],
    basicNames: [
      "en-US-Standard-B",
      "en-US-Standard-C",
      "en-US-Standard-D",
      "en-US-Standard-E",
    ],
  },
  {
    languageCode: {
      value: "es-ES",
      label: "Español (España)",
    },
    wavenetNames: [],
    basicNames: ["es-ES-Standard-A"],
  },
  {
    languageCode: {
      value: "fil-PH",
      label: "Filipino (Pilipinas)",
    },
    wavenetNames: ["fil-PH-Wavenet-A"],
    basic: ["fil-PH-Standard-A"],
  },
  {
    languageCode: {
      value: "fr-CA",
      label: "Français (Canada)",
    },
    wavenetNames: [
      "fr-CA-Wavenet-A",
      "fr-CA-Wavenet-B",
      "fr-CA-Wavenet-C",
      "fr-CA-Wavenet-D",
    ],
    basicNames: [
      "fr-CA-Standard-A",
      "fr-CA-Standard-B",
      "fr-CA-Standard-C",
      "fr-CA-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "fr-FR",
      label: "Français (France)",
    },
    wavenetNames: [
      "fr-FR-Wavenet-A",
      "fr-FR-Wavenet-B",
      "fr-FR-Wavenet-C",
      "fr-FR-Wavenet-D",
      "fr-FR-Wavenet-E",
    ],
    basicNames: [
      "fr-FR-Standard-A",
      "fr-FR-Standard-B",
      "fr-FR-Standard-C",
      "fr-FR-Standard-D",
      "fr-FR-Standard-E",
    ],
  },
  {
    languageCode: {
      value: "it-IT",
      label: "Italiano (Italia)",
    },
    wavenetNames: [
      "it-IT-Wavenet-A",
      "it-IT-Wavenet-B",
      "it-IT-Wavenet-C",
      "it-IT-Wavenet-D",
    ],
    basicNames: [
      "it-IT-Standard-A",
      "it-IT-Standard-B",
      "it-IT-Standard-C",
      "it-IT-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "hu-HU",
      label: "Magyar (Magyarország)",
    },
    wavenetNames: ["hu-HU-Wavenet-A"],
    basicNames: ["hu-HU-Standard-A"],
  },
  {
    languageCode: {
      value: "nl-NL",
      label: "Nederlands (Nederland)",
    },
    wavenetNames: [
      "nl-NL-Wavenet-A",
      "nl-NL-Wavenet-B",
      "nl-NL-Wavenet-C",
      "nl-NL-Wavenet-D",
      "nl-NL-Wavenet-E",
    ],
    basicNames: [
      "nl-NL-Standard-A",
      "nl-NL-Standard-B",
      "nl-NL-Standard-C",
      "nl-NL-Standard-D",
      "nl-NL-Standard-E",
    ],
  },
  {
    languageCode: {
      value: "nb-NO",
      label: "Norsk bokmål (Norge)",
    },
    wavenetNames: [
      "nb-no-Wavenet-E",
      "nb-NO-Wavenet-A",
      "nb-NO-Wavenet-B",
      "nb-NO-Wavenet-C",
      "nb-NO-Wavenet-D",
    ],
    basicNames: [
      "nb-no-Standard-E",
      "nb-NO-Standard-A",
      "nb-NO-Standard-B",
      "nb-NO-Standard-C",
      "nb-NO-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "pl-PL",
      label: "Polski (Polska)",
    },
    wavenetNames: [
      "pl-PL-Wavenet-A",
      "pl-PL-Wavenet-B",
      "pl-PL-Wavenet-C",
      "pl-PL-Wavenet-D",
      "pl-PL-Wavenet-E",
    ],
    basicNames: [
      "pl-PL-Standard-E",
      "pl-PL-Standard-A",
      "pl-PL-Standard-B",
      "pl-PL-Standard-C",
      "pl-PL-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "pt-BR",
      label: "Português (Brasil)",
    },
    wavenetNames: ["pt-BR-Wavenet-A"],
    basicNames: ["pt-BR-Standard-A"],
  },
  {
    languageCode: {
      value: "pt-PT",
      label: "Português (Portugal)",
    },
    wavenetNames: [
      "pt-PT-Wavenet-A",
      "pt-PT-Wavenet-B",
      "pt-PT-Wavenet-C",
      "pt-PT-Wavenet-D",
    ],
    basicNames: [
      "pt-PT-Standard-A",
      "pt-PT-Standard-B",
      "pt-PT-Standard-C",
      "pt-PT-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "sk-SK",
      label: "Slovenčina (Slovensko)",
    },
    wavenetNames: ["sk-SK-Wavenet-A"],
    basicNames: ["sk-SK-Standard-A"],
  },
  {
    languageCode: {
      value: "fi-FI",
      label: "Suomi (Suomi)",
    },
    wavenetNames: ["fi-FI-Wavenet-A"],
    basicNames: ["fi-FI-Standard-A"],
  },
  {
    languageCode: {
      value: "sv-SE",
      label: "Svenska (Sverige)",
    },
    wavenetNames: ["sv-SE-Wavenet-A"],
    basicNames: ["sv-SE-Standard-A"],
  },
  {
    languageCode: {
      value: "vi-VN",
      label: "Tiếng Việt (Việt Nam)",
    },
    wavenetNames: [
      "vi-VN-Wavenet-A",
      "vi-VN-Wavenet-B",
      "vi-VN-Wavenet-C",
      "vi-VN-Wavenet-D",
    ],
    basicNames: [
      "vi-VN-Standard-A",
      "vi-VN-Standard-B",
      "vi-VN-Standard-C",
      "vi-VN-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "tr-TR",
      label: "Türkçe (Türkiye)",
    },
    wavenetNames: [
      "tr-TR-Wavenet-A",
      "tr-TR-Wavenet-B",
      "tr-TR-Wavenet-C",
      "tr-TR-Wavenet-D",
      "tr-TR-Wavenet-E",
    ],
    basicNames: [
      "tr-TR-Standard-A",
      "tr-TR-Standard-B",
      "tr-TR-Standard-C",
      "tr-TR-Standard-D",
      "tr-TR-Standard-E",
    ],
  },
  {
    languageCode: {
      value: "cs-CZ",
      label: "Čeština (Česká republika)",
    },
    wavenetNames: ["cs-CZ-Wavenet-A"],
    basicNames: ["cs-CZ-Standard-A"],
  },
  {
    languageCode: {
      value: "el-GR",
      label: "Ελληνικά (Ελλάδα)",
    },
    wavenetNames: ["el-GR-Wavenet-A"],
    basicNames: ["el-GR-Standard-A"],
  },
  {
    languageCode: {
      value: "ru-RU",
      label: "Русский (Россия)",
    },
    wavenetNames: [
      "ru-RU-Wavenet-A",
      "ru-RU-Wavenet-B",
      "ru-RU-Wavenet-C",
      "ru-RU-Wavenet-D",
      "ru-RU-Wavenet-E",
    ],
    basicNames: [
      "ru-RU-Standard-A",
      "ru-RU-Standard-B",
      "ru-RU-Standard-C",
      "ru-RU-Standard-D",
      "ru-RU-Standard-E",
    ],
  },
  {
    languageCode: {
      value: "uk-UA",
      label: "Українська (Україна)",
    },
    wavenetNames: ["uk-UA-Wavenet-A"],
    basicNames: ["uk-UA-Standard-A"],
  },
  {
    languageCode: {
      value: "hi-IN",
      label: "हिन्दी (भारत)",
    },
    wavenetNames: ["hi-IN-Wavenet-A", "hi-IN-Wavenet-B", "hi-IN-Wavenet-C"],
    basicNames: ["hi-IN-Standard-A", "hi-IN-Standard-B", "hi-IN-Standard-C"],
  },
  {
    languageCode: {
      value: "ja-JP",
      label: "日本語（日本)",
    },
    wavenetNames: [
      "ja-JP-Wavenet-A",
      "ja-JP-Wavenet-B",
      "ja-JP-Wavenet-C",
      "ja-JP-Wavenet-D",
    ],
    basicNames: [
      "ja-JP-Standard-A",
      "ja-JP-Standard-B",
      "ja-JP-Standard-C",
      "ja-JP-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "cmn-CN",
      label: "普通话 (中国大陆)",
    },
    wavenetNames: [
      "cmn-CN-Wavenet-A",
      "cmn-CN-Wavenet-B",
      "cmn-CN-Wavenet-C",
      "cmn-CN-Wavenet-D",
    ],
    basicNames: [
      "cmn-CN-Standard-A",
      "cmn-CN-Standard-B",
      "cmn-CN-Standard-C",
      "cmn-CN-Standard-D",
    ],
  },
  {
    languageCode: {
      value: "ko-KR",
      label: "한국어 (대한민국)",
    },
    wavenetNames: [
      "ko-KR-Wavenet-A",
      "ko-KR-Wavenet-B",
      "ko-KR-Wavenet-C",
      "ko-KR-Wavenet-D",
    ],
    basicNames: [
      "ko-KR-Standard-A",
      "ko-KR-Standard-B",
      "ko-KR-Standard-C",
      "ko-KR-Standard-D",
    ],
  },
]
